import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../header";

function AppLayout() {
  return (
    <>
      <Header />
      <div className="main_container">
        <div className="flex h-full ">
          <Outlet />
        </div>
      </div>
    </>
  );
}

export default AppLayout;
